import Vue from 'vue';
import Vuex from 'vuex';
// import {router} from "./router";
import commin from "./commin";
Vue.use(Vuex);

import axios from "axios";

const stores = new Vuex.Store({
    state: {
        setTimes: -1,
        timer: null,
        audioIsPause: false,
        classTypeId: "",
        officeId: "",
        errorMsg: "",
        addHistoryTimer: null,
        bookId: 0,
        isLogout: false,
        wxConfigData: {},
        defaultLink:'',
        isFirstIos: false,
        isFirstAudioLoad: true,


        toAudioPage: "",
        bookInfo: {},
        chapterPages: {
            pageSize: 20,
            pageNum: 1,
            prevNum: 1,
            nextNum: 1,
            totalPage: 1,
            totalRow: 1
        },
        chapterHistory: {
            historyRank: -1,
            historyCurrentTime: -1
        },
        historical: true, // 是否是从历史开始的列表
        chapterList: [],
        actChapter: {
            actChapterIdx: 0,
            rank: 1,
            audioUrl: "",
            name: "",
            chapterid: 0,
        },
        audioInfo: {
            duration: 0,
            currentTime: 0,
            playbackRate: 1,
            isPlay: "n",
            firstPlay: "y",
        }
    },
    mutations: {
        setClassTypeId(state) {
            state.classTypeId = localStorage.getItem("classTypeId");
        },
        setOfficeId(state) {
            state.officeId = localStorage.getItem("officeId");
        },
        setErrorMsg(state, msg) {
            state.errorMsg = msg;
        },
        setTimer(state, dates) {
            state.setTimes = dates;
            state.timer = setInterval(()=>{
                state.setTimes--;
                // console.log(state.setTimes)
                if( state.setTimes == 0 ){
                    clearInterval(state.timer);
                    return false;
                }
            },1000)
        },
        clearTimer(state){
            if( !state.timer ) return false;
            clearInterval(state.timer);
        },
        addHistory(state) {
            state.addHistoryTimer = setInterval(()=>{
                commin.fn.addHistory();
            },10000)
        },
        clearAddHistory(state){
            clearInterval(state.addHistoryTimer);
        },
        setTimesDefault(state, dates){
            state.setTimes = dates;
        },
        setBookId(state, bookId) {
            state.bookId = bookId;
        },
        setaudioIsPauseT(state) {
            state.audioIsPause = true;
        },
        setaudioIsPauseF(state) {
            state.audioIsPause = false;
        },
        setIsLogout(state, msg) {
            state.isLogout = msg;
        },
        setwxConfigData(state, obj) {
            state.wxConfigData = obj;
        },
        setdefaultLink(state, val) {
            state.defaultLink = val;
        },
        setisFirstIos(state, bool) {
            state.isFirstIos = bool;
        },
        setisFirstAudioLoad(state, bool) {
            state.isFirstAudioLoad = bool;
        },
        

        setToAudioPage(state, val) {
            // 从val页面跳转到audio页面
            state.toAudioPage = val;
        },
        setBookInfo(state, obj) {
            // 当前播放的书籍详情
            state.bookInfo = obj;
        },
        setChapterList(state, arr) {
            // 章节列表
            state.chapterList = arr;
        },
        setHistorical(state, boolean) {
            // 获取章节是否从历史开始
            state.historical = boolean;
        },
        setChapterPages(state, obj) {
            // 章节列表当前页
            state.chapterPages.pageNum = !obj.pageNum ? state.chapterPages.pageNum : obj.pageNum;
            // 章节列表上一页
            state.chapterPages.prevNum = !obj.prevNum ? state.chapterPages.prevNum : obj.prevNum;
            // 章节列表下一页
            state.chapterPages.nextNum = !obj.nextNum ? state.chapterPages.nextNum : obj.nextNum;
            // 章节列表总页数
            state.chapterPages.totalPage = !obj.totalPage ? state.chapterPages.totalPage : obj.totalPage;
        },
        setActChapter(state, obj) {
            // 当前音频索引
            state.actChapter.actChapterIdx = !obj.actChapterIdx && obj.actChapterIdx != 0 ? state.actChapter.actChapterIdx : obj.actChapterIdx;
            // 当前播放音频序号
            state.actChapter.rank = !obj.rank ? state.actChapter.rank : obj.rank;
            // 当前播放音频链接
            state.actChapter.audioUrl = !obj.audioUrl ? state.actChapter.audioUrl : obj.audioUrl;
            // 当前播放音频名字
            state.actChapter.name = !obj.name ? state.actChapter.name : obj.name;
            // 当前播放音频id
            state.actChapter.chapterid = !obj.chapterid ? state.actChapter.chapterid : obj.chapterid;
        },
        setAudioInfo(state, obj) {
            // 当前播放时间
            state.audioInfo.currentTime = !obj.currentTime ? state.audioInfo.currentTime : obj.currentTime;
            // 音频总时长
            state.audioInfo.duration = !obj.duration ? state.audioInfo.duration : obj.duration;
            // 音频播放倍速
            state.audioInfo.playbackRate = !obj.playbackRate ? state.audioInfo.playbackRate : obj.playbackRate;
            // 暂停/播放
            state.audioInfo.isPlay = !obj.isPlay ? state.audioInfo.isPlay : obj.isPlay;
            // 是否第一次播放
            state.audioInfo.firstPlay = !obj.firstPlay ? state.audioInfo.firstPlay : obj.firstPlay;
            // 定时器的设定决定播不播放
            !obj.setTime ? "" : state.chapterList[state.actChapter.actChapterIdx].setTime = obj.setTime
        },
        setChapterHistory(state, obj) {
            // 历史音频播放序号
            state.chapterHistory.historyRank = obj.historyRank;
        },
    }
})


// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(
    config => {
        // config.headers = {'X-Requested-With': 'XMLHttpRequest'};
        
        // if( localStorage.getItem("token" + localStorage.getItem("version")) ){
        //     config.headers.token = localStorage.getItem("token" + localStorage.getItem("version") );
        // }
        // stores.state.isLoading = true;
        return config;
    },
    error => {
        return Promise.reject(error.response);
    }
);
  
// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
    response => {
        // if( JSON.parse(response.data).result == 500 ) {
            // router.replace({
            //     path: "/404"
            // })
        // }
        // stores.state.isLoading = false;
        return response;
    },
    error => {
        return Promise.reject(error.response) // 返回接口返回的错误信息
    }
);

export default stores;